<template>
  <b-row>
    <b-col cols="12">
      <book-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import BookContent from './BookContent.vue'

export default {
  components: {
    BRow,
    BCol,

    BookContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>